import { Component, Inject } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
    selector: 'app-leave-review',
    templateUrl: './leave-review.component.html',
    styleUrls: ['./leave-review.component.css'],
})
export class LeaveReviewComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<LeaveReviewComponent>,
    ) {}

    // @todo: add custom validators for the form, using emptyReview() rule
    reviewFormGroup: FormGroup = new FormGroup({
        comment: new FormControl('', [Validators.minLength(3)]),
        star_rating: new FormControl(),
        ppa_id: new FormControl(this.data.ppa.id),
        is_anonymous: new FormControl(false),
    })


    saveDraft() {}

    /** Tapping the selected star again steps down one; below 1 star is "no rating" (null, never 0 - the backend wants 1-5). */
    rateReview(rating: number) {
        const control = this.reviewFormGroup.get(['star_rating'])
        if (rating === control?.value) {
            control?.setValue(rating > 1 ? rating - 1 : null)
        } else {
            control?.setValue(rating)
        }
    }

    saveReview() {
        if (this.reviewFormGroup.valid) {
            this.dialogRef.close(this.reviewFormGroup.value)
        }
    }

    close() {
        this.dialogRef.close()
    }

    get emptyReview(): boolean {
        return (
            this.reviewFormGroup.get(['comment'])?.value?.length < 3 &&
            !this.reviewFormGroup.get(['star_rating'])?.value
        )
    }
}
